import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/terms-and-conditions')({
  component: () => <Navigate to="/algemene-voorwaarden" replace />,
});
